function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#7B7B7B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(2)"
}, React.createElement("rect", {
  width: 11.5,
  height: 9.25,
  x: .25,
  y: 6.25,
  fill: "#D5D5D5",
  rx: 1.5
}), React.createElement("path", {
  d: "M2.25,6.25 L2.25,4.25 C2.25,2.17893219 3.92893219,0.5 6,0.5 C8.0710678,0.5 9.75,2.17893219 9.75,4.25 L9.75,6.25"
}), React.createElement("line", {
  x1: 6,
  x2: 6,
  y1: 10,
  y2: 12
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/lock.9d3768a3.svg";
export { SvgComponent as ReactComponent };